import { Documents } from "../../../common/index";

const EmployeeProfileDocuments = ({ employee }) => {
  return <Documents data={employee} />;
};

export default EmployeeProfileDocuments;
